/* eslint-disable no-magic-numbers */

import L from 'leaflet';

L.PicImageOverlay = L.ImageOverlay.extend({
  onAdd() {
    if (!this._image) {
      this._initImage();

      if (this.options.opacity < 1) {
        this._updateOpacity();
      }
    }

    if (this.options.interactive) {
      L.DomUtil.addClass(this._image, 'leaflet-interactive');
      this.addInteractiveTarget(this._image);
    }

    this.getPane().appendChild(this._image);
    this._reset();
  },

  _initImage() {
    const container = this._image = L.DomUtil.create(
      'span',
      `pic-container leaflet-image-layer ${(this._zoomAnimated ? 'leaflet-zoom-animated' : '')}`
    );
    const pic = L.DomUtil.create('span');
    L.DomUtil.addClass(pic, 'pic-container__image');

    const img = L.DomUtil.create('img');
    L.DomUtil.addClass(img, 'pic-container__img');
    pic.appendChild(img);

    if (this.options.flipImage) {
      L.DomUtil.addClass(container, 'pic-container--flip');
      const flipImage = L.DomUtil.create('img');
      L.DomUtil.addClass(flipImage, 'pic-container__flip');
      flipImage.onload = L.bind(this.fire, this, 'load');
      flipImage.src = this.options.flipImage;
      pic.appendChild(flipImage);
    }

    container.appendChild(pic);

    container.onselectstart = L.Util.falseFn;
    container.onmousemove = L.Util.falseFn;

    img.onload = L.bind(this.fire, this, 'load');
    img.src = this._url;

    // Urban extension
    img.alt = this.options.alt;
    img.title = this.options.title;
  },
});

L.picImageOverlay = function (url, bounds, options) {
  return new L.PicImageOverlay(url, bounds, options);
};

export default {
  template: '<div></div>',
  props: ['map', 'faces', 'show'],
  mounted() {
    this.pics = [];
  },
  methods: {
    regenerateFaces() {
      if (this.show) {
        this.faces.forEach((face) => {
          const faceSquare = L.latLngBounds(face.bounds);
          const photo = (face.sideLength >= 3) ? face.purchasePhoto.mediumUrl : face.purchasePhoto.smallUrl;
          const image = L.picImageOverlay(photo, faceSquare, {
            pane: 'faces',
            interactive: true,
            flipImage: (face.campaignImage) ? face.campaignImage.mediumUrl : null,
          });
          image.addTo(this.map);
          if (image._image) {
            image._image.style.backgroundColor = face.purchasePhoto.dominantColor;
          }
          this.pics.push(image);
        });
      } else {
        this.pics.forEach((image) => {
          this.map.removeLayer(image);
        });
      }
    },
  },
  watch: {
    show() {
      if (this.map && this.map.getPane('faces')) this.regenerateFaces();
    },
    faces() {
      if (this.map && this.map.getPane('faces')) this.regenerateFaces();
    },
    map() {
      this.facesPane = this.map.createPane('faces');
      this.facesPane.style.zIndex = 400;
      this.regenerateFaces();
    },
  },
};
